import { render } from "./BranchFilterModal.vue?vue&type=template&id=87f7b28e&scoped=true"
import script from "./BranchFilterModal.vue?vue&type=script&lang=js"
export * from "./BranchFilterModal.vue?vue&type=script&lang=js"

import "./BranchFilterModal.vue?vue&type=style&index=0&id=87f7b28e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87f7b28e"]])

export default __exports__